/**获取选题列表*/
import {applicationName} from "../utils";

export const getTopicSelectionList = ({start,size,queryStr,tsListStatus,tsStatus,tsStartDate,tsEndDate,tsDirection})=> new Promise((resolve, reject) => {
    let url = "/cm-sites-"+applicationName()+"/topicSelection/list";
    let time = new Date().getTime();
    let params = {
        start,size,queryStr,tsListStatus,tsStatus,tsStartDate,tsEndDate,tsDirection,time
    };
    window.$.ajax({
        type:"get",
        url: url,
        data:params,
        dataType:"json",
        success:function (result) {
            resolve(result);
        },
        error:function (e) {
            console.error(e);
            reject({});
        }
    });
})

/**
 * 新增选题
 * @param topicSelection
 * @returns {Promise<any>}
 */
export const addTopicSelection = (topicSelection)=> new Promise((resolve, reject) => {
    let url = "/cm-sites-"+applicationName()+"/topicSelection/add";
    window.$.ajax({
        type:"post",
        url: url,
        contentType:"application/json",
        data:JSON.stringify(topicSelection),
        dataType:"json",
        success:function (result) {
            resolve(result);
        },
        error:function (e) {
            console.error(e);
            reject({});
        }
    });
});

/**
 * 获取pms端用户列表
 * @returns {Promise<any>}
 */
export const getPmsUser = ()=> new Promise((resolve, reject) => {
    let time = new Date().getTime();
    let url = "/cm-sites-"+applicationName()+"/user/getPmsUser?time="+time;
    window.$.ajax({
        type:"get",
        url: url,
        dataType:"json",
        success:function (result) {
            resolve(result);
        },
        error:function (e) {
            console.error(e);
            reject({});
        }
    });
})

/**
 * 修改选题
 * @param topicSelection
 * @returns {Promise<any>}
 */
export const editTopicSelection = (topicSelection)=> new Promise((resolve, reject) => {
    let url = "/cm-sites-"+applicationName()+"/topicSelection/edit";
    window.$.ajax({
        type:"post",
        url: url,
        contentType:"application/json",
        data:JSON.stringify(topicSelection),
        dataType:"json",
        success:function (result) {
            resolve(result);
        },
        error:function (e) {
            console.error(e);
            reject({});
        }
    });
});

/**
 * 修改选题状态
 * @param id
 * @param tsStatus
 * @returns {Promise<any>}
 */
export const editStatusTopicSelection = (id, tsStatus)=> new Promise((resolve, reject) => {
    let url = "/cm-sites-"+applicationName()+"/topicSelection/editStatus";
    let params = {
        id, tsStatus
    };
    window.$.ajax({
        type:"post",
        url: url,
        data:params,
        dataType:"json",
        success:function (result) {
            resolve(result);
        },
        error:function (e) {
            console.error(e);
            reject({});
        }
    });
});

/**
 * 通过id删除选题管理
 * @param id
 * @returns {Promise<any>}
 */
export const deleteTopicSelectionById = (id)=> new Promise((resolve, reject) => {
    let url = "/cm-sites-"+applicationName()+"/topicSelection/deleteById";
    let params = {
        id
    };
    window.$.ajax({
        type:"post",
        url: url,
        data:params,
        dataType:"json",
        success:function (result) {
            resolve(result);
        },
        error:function (e) {
            console.error(e);
            reject({});
        }
    });
});

/**
 * 根据账号获取用户列表
 * @param accountsStr
 * @returns {Promise<any>}
 */
export const getByAccounts = (accountsStr)=> new Promise((resolve, reject) => {
    let time = new Date().getTime();
    let url = "/cm-sites-"+applicationName()+"/user/getByAccounts";
    let params = {
        accountsStr,time
    };
    window.$.ajax({
        type:"post",
        url: url,
        data:params,
        dataType:"json",
        success:function (result) {
            resolve(result);
        },
        error:function (e) {
            console.error(e);
            reject({});
        }
    });
});

/**
 * 指派写作
 * @param id
 * @param tsAppointee
 * @returns {Promise<any>}
 */
export const assignedWriting = (id, tsAppointee, tsRemark)=> new Promise((resolve, reject) => {
    let url = "/cm-sites-"+applicationName()+"/topicSelection/assignedWriting";
    let params = {
        id, tsAppointee, tsRemark
    };
    window.$.ajax({
        type:"post",
        url: url,
        data:params,
        dataType:"json",
        traditional: true,//参数中有数组，防止深度序列化
        success:function (result) {
            resolve(result);
        },
        error:function (e) {
            console.error(e);
            reject({});
        }
    });
});

/**
 * 根据id获取
 * @param id
 * @returns {Promise<any>}
 */
export const getTopicSelectionById = (id)=> new Promise((resolve, reject) => {
    let time = new Date().getTime();
    let url = "/cm-sites-"+applicationName()+"/topicSelection/getById";
    let params = {
        id,time
    };
    window.$.ajax({
        type:"get",
        url: url,
        data:params,
        dataType:"json",
        success:function (result) {
            resolve(result);
        },
        error:function (e) {
            console.error(e);
            reject({});
        }
    });
})